import autobind from 'autobind-decorator';
import config from 'config';

export default class ChatCompanion {
  constructor(reportError) {
    this.isAvailable = false;
    this.reportError = reportError;
  }

  async status() {
    return (await fetch(`${config.companionBaseUrl}status`)).ok;
  }

  @autobind
  async checkAvailability() {
    try {
      if (await this.status()) {
        this.isAvailable = true;
      }
    } catch (err) {
      this.reportError(`Could not retrieve chat companion status: ${err.message}`);
    }

    return this.isAvailable;
  }

  @autobind
  async printByFileGuid(guid, name) {
    const response = await fetch(`${config.companionBaseUrl}cmd/print/${guid}/${name}/`);

    if (!response.ok) {
      throw new Error(await response.text());     
    }
  }
}



// WEBPACK FOOTER //
// ./actions/lib/companion.js